/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmailTemplateRequest
 */
export interface CreateEmailTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    body: string;
}

/**
 * Check if a given object implements the CreateEmailTemplateRequest interface.
 */
export function instanceOfCreateEmailTemplateRequest(value: object): value is CreateEmailTemplateRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function CreateEmailTemplateRequestFromJSON(json: any): CreateEmailTemplateRequest {
    return CreateEmailTemplateRequestFromJSONTyped(json, false);
}

export function CreateEmailTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'key': json['key'],
        'displayName': json['displayName'],
        'subject': json['subject'],
        'body': json['body'],
    };
}

export function CreateEmailTemplateRequestToJSON(json: any): CreateEmailTemplateRequest {
    return CreateEmailTemplateRequestToJSONTyped(json, false);
}

export function CreateEmailTemplateRequestToJSONTyped(value?: CreateEmailTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'key': value['key'],
        'displayName': value['displayName'],
        'subject': value['subject'],
        'body': value['body'],
    };
}

